export const RadioInput = ({ inputProps, id, idx, language, option }) => {
  return (
    <label className={`label-container ps-0 mb-0`}>
      <input {...inputProps} id={id + idx} />
      <span className="checkmark" />
      <span className="label-text fw-semibold fs-4">{option.label?.locales?.[language]}</span>
    </label>
  );
};
